import { createElement } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'
// eslint-disable-next-line
import * as Icons from 'glob:./icons/*.js'

const Icon = ({ className, icon, color, size }) => {
    const newClassName = classnames('icon', icon, { [`color-${color}`]: !!color }, className)
    const comp = Icons[_.chain(icon).camelCase().upperFirst().value()]

    const props = {
        className: newClassName,
        style: { width: `${size}em`, height: `${size}em` },
    }

    // Get the correct icon from this array of functions
    return comp ? createElement(comp, props) : null
}

Icon.defaultProps = {
    size: 1,
}

Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    color: PropTypes.oneOf(['lighter', 'white', 'darker']),
    size: PropTypes.number,
}

export default Icon



// WEBPACK FOOTER //
// ./src/ui/Icon.js